import { useCallback, useState } from 'react';

import { EpgPlayerState } from '../types';

export default function usePlayerState({
    videoItem,
    playbackType,
}: EpgPlayerState) {
    const [playerState, _setPlayerState] = useState<EpgPlayerState>({
        videoItem,
        playbackType,
    });

    const setPlayerState = useCallback(
        (partialState: Partial<EpgPlayerState>) => {
            _setPlayerState((state) => {
                return {
                    ...state,
                    ...partialState,
                };
            });
        },
        [],
    );

    return {
        setPlayerState,
        playerState,
    };
}
